import { DocumentTypes } from '~/pages/IncomeCalculator/enums';

export const getVABenefitLetterDocumentTypeId = (): string => {
  const environment = globalThis.globalConfig?.api?.environment ?? '';

  if (environment === 'PRD') {
    return DocumentTypes.VABenefitLetterProd;
  }

  if (environment === 'STG') {
    return DocumentTypes.VABenefitLetterStage;
  }

  return DocumentTypes.VABenefitLetterInt;
};
